/**
 * Created by asiulik on 19.01.2018.
 */

define(['jquery', 'lodash', './store'], function($, _, Store){

    function FavouriteStore(){ this.init(); }

    FavouriteStore.prototype = _.clone(Store.prototype);

    FavouriteStore.prototype.setFavourites = function(element){
        if(!!element) {
            this.setStoreValue('favourites',  JSON.stringify(element));
        }
    };

    FavouriteStore.prototype.getFavourites = function(){
        var store = this.getStoreValue('favourites');
        if (store !== undefined ) {
            return JSON.parse(store);
        }

    };

    FavouriteStore.prototype.removeFavourites = function(){};

    return FavouriteStore;

});


// WEBPACK FOOTER //
// ./Private/Scripts/modules/store/favouriteStore.js